import {
  EmailIcon,
  SMSIcon,
  SlackIcon,
  PushIcon,
  WebhookIcon,
  ExitIcon,
  TimeDelayIcon,
  TimeWindowIcon,
  WaitUntilIcon,
  JumpToIcon,
  InAppMessageIcon,
  UserAttributeIcon,
  ExperimentIcon,
  AiResponseIcon,
} from "pages/FlowBuilderv2/Icons";
import { FlowBuilderDrawerFixture } from "./FlowBuilderDrawer";

export enum DrawerAction {
  EMAIL = "email",
  INTERNAL_EMAIL = "internalEmail",
  SMS = "sms",
  SLACK = "slack",
  PUSH = "push",
  WEBHOOK = "webhook",
  IN_APP_MESSAGE = "inAppMessage",
  TRACKER = "tracker",
  JUMP_TO = "jumpTo",
  EXIT = "exit",
  WAIT_UNTIL = "waitUntil",
  TIME_DELAY = "timeDelay",
  TIME_WINDOW = "timeWindow",
  MULTISPLIT = "multisplit",
  EXPERIMENT = "experiment",
  USER_ATTRIBUTE = "userAttribute",
  AI_RESPONSE = "aiResponse",
  RESPONSE_BRANCH = "responseBranch",
  RICOCHET = "ricochet",
}

const flowBuilderDrawerFixtures: FlowBuilderDrawerFixture[] = [
  {
    groupName: "Messages & Steps",
    children: [
      {
        id: DrawerAction.EMAIL,
        icon: EmailIcon(),
        text: "Email",
        description:
          "Sends the selected email template to the contact or to specific recipients using your connected email provider.",
      },
      {
        id: DrawerAction.SMS,
        icon: SMSIcon(),
        text: "SMS",
        description:
          "Sends the selected SMS template to the contact or to specific phone numbers via your Twilio or Telnyx connection.",
      },
      {
        id: DrawerAction.SLACK,
        icon: SlackIcon(),
        text: "Slack",
        description:
          "Sends a Slack DM to the contact (looked up by their slackId or email) using the connected Slack workspace.",
      },
      {
        id: DrawerAction.PUSH,
        icon: PushIcon(),
        text: "Push Notification",
        description:
          "Sends a Firebase push notification to the contact's iOS and/or Android device.",
      },
      {
        id: DrawerAction.WEBHOOK,
        icon: WebhookIcon(),
        text: "Webhook",
        description:
          "Fires the template's configured HTTP request to an external URL with the contact's tags interpolated.",
      },
      {
        id: DrawerAction.RICOCHET,
        icon: WebhookIcon(),
        text: "Ricochet",
        description:
          "Updates the current LeadStats lead in Ricochet by changing status, adding tags, creating tasks, or adding notes.",
      },
      {
        id: DrawerAction.IN_APP_MESSAGE,
        icon: InAppMessageIcon(),
        text: "In App Message",
        description:
          "Queues an in-app modal the contact sees the next time they're active in your app.",
      },
      {
        id: DrawerAction.AI_RESPONSE,
        icon: AiResponseIcon(),
        text: "AI Response",
        description:
          "Starts a per-contact AI conversation on the chosen channel; the AI sends the first message and handles replies.",
      },
      //{
      //  id: DrawerAction.TRACKER,
      //  icon: CustomModalIcon(),
      //  text: "Onboarding",
      //},
      {
        id: DrawerAction.JUMP_TO,
        icon: JumpToIcon(),
        text: "Jump To",
        description:
          "Sends the contact to a different step elsewhere in this workflow. Used to build loops.",
      },
      {
        id: DrawerAction.EXIT,
        icon: ExitIcon(),
        text: "Exit",
        description:
          "Terminates the workflow for this contact. Their location stops moving.",
      },
    ],
  },
  {
    groupName: "Delays & Triggers",
    children: [
      {
        id: DrawerAction.WAIT_UNTIL,
        icon: WaitUntilIcon(),
        text: "Wait Until",
        description:
          "Holds the contact until any one of the configured event branches fires (message clicked, attribute changed, custom event), or the max-time fallback elapses.",
      },
      {
        id: DrawerAction.RESPONSE_BRANCH,
        icon: WaitUntilIcon(),
        text: "Response Branch",
        description:
          "Holds the contact after a message and routes them based on what they reply: keyword/contains/regex match per branch, an AI fallback that classifies replies that don't keyword-match, an 'Any other reply' catch-all, and a 'No reply within X' timeout.",
      },
      {
        id: DrawerAction.TIME_DELAY,
        icon: TimeDelayIcon(),
        text: "Time Delay",
        description:
          "Holds the contact for a fixed duration (days/hours/minutes) from when they entered the step, then advances.",
      },
      {
        id: DrawerAction.TIME_WINDOW,
        icon: TimeWindowIcon(),
        text: "Time Window",
        description:
          "Holds the contact until 'now' falls inside a configured date range or weekly day/time window, then advances.",
      },
    ],
  },
  {
    groupName: "Audience Split",
    children: [
      {
        id: DrawerAction.MULTISPLIT,
        // TODO: change icon
        icon: UserAttributeIcon(),
        text: "Multisplit",
        description:
          "Routes the contact down the first branch whose attribute or event conditions match, with an 'All others' catch-all.",
      },
      {
        id: DrawerAction.EXPERIMENT,
        icon: ExperimentIcon(),
        text: "Experiment",
        description:
          "Randomly routes the contact down one of N branches according to the configured ratio percentages (an A/B/N test).",
      },
      // {
      //   id: DrawerAction.TIME_DELAY,
      //   icon: TimeDelayIcon(),
      //   text: "A/B Test",
      // },
    ],
  },
];

export default flowBuilderDrawerFixtures;
